// extracted by mini-css-extract-plugin
export default {"ProductName":"Product_ProductName__wBzbh","ProductName--Image":"Product_ProductName--Image__fqPcZ"};